import { axios } from '@Root/API'

export const get = () => {
  return axios.get('admin/notification/applicant-template')
}
